<template>
    <div style="display: flex; align-items: flex-start; padding: 6px 0 12px 0; border-bottom: 1px solid #eee;" :class="value === '0' ? 'advanced-settings-disabled' : 'advanced-settings-enabled'">
        <v-switch
            style="flex-grow: 0; margin: 0; margin-right: 5px;"
            v-model="value"
            hide-details
            color="blue"
            :false-value="String(0)"
            :true-value="String(1)"
            @change="changeActive"
        />
        <div :style="{ color : value === '0' ? '#aaa;' : '#000;'}">
            <h4 style="margin-top: 7px; font-weight: 600">{{ title }}</h4>
            <p style="font-size: 12px; line-height: 1.2; margin: 5px 0 0 0; padding: 0;" v-if="desc">{{ desc }}</p>
        </div>
    </div>
</template>
<style>
    .advanced-settings-disabled h4 {
        color: #aaa!important;
    }
    .advanced-settings-enabled p {
        color: #777!important;
    }
    .advanced-settings-disabled p {
        color: #ddd!important;
    }
</style>

<script>
export default {
    props: {
        storageKey: {
            type: String,
            default: "",
        },
        title: {
            type: String,
            default: "",
        },
        desc: {
            type: String,
            default: "",
        },
    },
    data: () => ({
        value: "0",
    }),
    created() {
        this.value = localStorage.getItem('adv-settings-' + this.storageKey) || "0";
    },
    methods: {
        changeActive() {
            this.$nextTick(() => {
                const keyName = 'adv-settings-' + this.storageKey;
                if (this.value === '1') localStorage.setItem(keyName, String(this.value));
                else localStorage.removeItem(keyName);
            });
        }
    },
}
</script>
